import { render, staticRenderFns } from "./tableDot.vue?vue&type=template&id=09a1977c&scoped=true"
import script from "./tableDot.vue?vue&type=script&lang=js"
export * from "./tableDot.vue?vue&type=script&lang=js"
import style0 from "./tableDot.vue?vue&type=style&index=0&id=09a1977c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a1977c",
  null
  
)

export default component.exports